// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"440":"ee5742ec","489":"e2571a36","491":"b78adbb7","696":"ba373edc","778":"ba373edc","806":"9e207cad","897":"a9cbb6a2"}[chunkId] + ".chunk.css";
};